import { useMemo } from 'react';

type IBlinkTextProps = {
    dynamicLabel?: string | (() => string);
    className?: string;
    isLastMessage?: boolean;
    supportedLanguages?: string[];
};

export default function DynamicLabel(props: IBlinkTextProps) {
    const { dynamicLabel, className, ...dynamicLabelProps } = props;
    const text = useMemo(
        // eslint-disable-next-line no-eval
        () => `${(eval(dynamicLabel as string) as Function)(dynamicLabelProps)}`,
        [dynamicLabel, dynamicLabelProps],
    );
    return (
        <div
            className={[className].filter((c) => !!c).join(' ')}
            key={text}
            dangerouslySetInnerHTML={{ __html: text }}
        />
    );
}
